import { HttpClient, HttpParams, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators'
import { environment } from 'src/environments/environment';
import { catchError, tap } from 'rxjs/operators';
import { Customer, CustomCategory, CustomerLazy, CustomerLazySearch, Pelephone, IsCustomerPhone } from '../../../../classes/Customers/Customer';
import { PopupItem } from 'src/classes/Common/PopupItem';
import { Screen } from '../../../../classes/Authorization/BusinessRole';
import { CustCard_1, CustomerIn, CustomerStepVisitIn } from '../../../../classes/Customers/CustCard_1';
import { CustCard_3 } from 'src/classes/Customers/CustCard_3';
import { CustCard_5 } from 'src/classes/Customers/CustCard_5';
import { City } from 'src/classes/Common/City';
import { Worker } from 'src/classes/Common/Worker';
import { SourceArrival } from 'src/classes/Customers/SourceArrival';
import { Occupation } from 'src/classes/Customers/Occupation';
import { Proposal } from 'src/classes/Customers/Proposal';
import { FullComment, CommentIn } from 'src/classes/Customers/FullComment';
import { Subscriber } from 'src/classes/Customers/Subscriber';
import { ServiceSubscriber } from 'src/classes/Customers/ServiceSubscriber';
import { CardColor, ServiceCardColor } from 'src/classes/Customers/CardColor';
import { StripIn, StripVisit, SubStripVisit, Visit } from 'src/classes/Customers/Visit';
import { sortEvents } from '@mobiscroll/angular/dist/js/core/shared/calendar-view/calendar-view.util';

@Injectable()
export class HttpServiceCustomer {

    constructor(private http: HttpClient) { }

    getCustomers() {
        return this.http.get<any>(environment.urlservbeautech + '/api/Customers/GetCustomers')
    }

    getCustomersLazy(customerlazy: CustomerLazy) {
        const body = {
            page: customerlazy.page,
            size: customerlazy.size,
            sortField: customerlazy.sortField,
            sortOrder: customerlazy.sortOrder
        };
        return this.http.post(environment.urlservbeautech + '/api/Customers/GetCustomersLazy', JSON.stringify(body)).toPromise();
    }

    getCustomersLazySearch(customerlazysearch: CustomerLazySearch) {
        const body = {
            page: customerlazysearch.page,
            size: customerlazysearch.size,
            sortField: customerlazysearch.sortField,
            sortOrder: customerlazysearch.sortOrder,
            sex: customerlazysearch.sex,
            classification: customerlazysearch.classification,
            category: customerlazysearch.category,
            search: customerlazysearch.search
        };
        return this.http.post(environment.urlservbeautech + '/api/Customers/GetCustomersLazySearch', JSON.stringify(body));
    }

    getCustomCategories() {
        return this.http.get<any>(environment.urlservbeautech + '/api/Customers/GetCustomCategories')
    }

    getItemsMenuByScreen(screen: Screen) {
        const body = { screen_id: screen.screen_id };
        return this.http.post(environment.urlservbeautech + '/api/Customers/GetMenuItemsSync', JSON.stringify(body));
    }

    getConfig() {
        return this.http.get<any>(environment.urlservbeautech + '/api/Customers/GetConfigSync')
    }

    getCustCard_1(customerin: CustomerIn) {
        const body = { customer_id: customerin.customer_id };
        return this.http.post(environment.urlservbeautech + '/api/CustomerCard/GetCustomerCard_1', JSON.stringify(body));
    }

    getCustCard_2(customerin: CustomerIn) {
        const body = { customer_id: customerin.customer_id };
        return this.http.post(environment.urlservbeautech + '/api/CustomerCard/GetCustomerCard_2', JSON.stringify(body));
    }

    getCustCard_3(customerin: CustomerIn) {
        const body = { customer_id: customerin.customer_id };
        return this.http.post(environment.urlservbeautech + '/api/CustomerCard/GetCustomerCard_3', JSON.stringify(body));
    }

    getCustCard_4(customerin: CustomerIn) {
        const body = { customer_id: customerin.customer_id };
        return this.http.post(environment.urlservbeautech + '/api/CustomerCard/GetCustomerCard_4', JSON.stringify(body));
    }

    getCustCard_5(customerin: CustomerIn) {
        const body = { customer_id: customerin.customer_id };
        return this.http.post(environment.urlservbeautech + '/api/CustomerCard/GetCustomerCard_5', JSON.stringify(body));
    }


    setCustCard_5(custcard_5: CustCard_5[]) {
        let json = JSON.stringify(custcard_5);
        const body = json;
        return this.http.post(environment.urlservbeautech + '/api/CustomerCard/SetCustCard_5', body);
    }



    async setCustCard_3(custcard_3: CustCard_3) {
        const body = {
            customerId: custcard_3.customerId,
            firstName: custcard_3.firstName,
            lastName: custcard_3.lastName,
            sex: custcard_3.sex,
            pelephone: custcard_3.pelephone,
            phone: custcard_3.phone,
            birthDay: custcard_3.birthDay,
            address: custcard_3.address,
            cityName: custcard_3.cityName,
            email: custcard_3.email,
            sourceName: custcard_3.sourceName,
            recommenderfl: custcard_3.recommenderfl,
            saparName: custcard_3.saparName,
            idOfCategery: custcard_3.idOfCategery,
            identicalNum: custcard_3.identicalNum,
            wedding_Date: custcard_3.wedding_Date,
            kindDrink: custcard_3.kindDrink,
            faceBook: custcard_3.faceBook,
            isSendSMS: custcard_3.isSendSMS,
            aditionalPhone: custcard_3.aditionalPhone,
            instLink: custcard_3.instLink,
            isBlockedMarketingMessages: custcard_3.isBlockedMarketingMessages,
            cityId: custcard_3.cityID,
            recommenderCustID: custcard_3.recommenderCustID,
            saparId: custcard_3.saparID,
            imagePath: custcard_3.imagePath,
            sourceId: custcard_3.sourceID,
            occupationId: custcard_3.occupationId,
            occupationName: custcard_3.occupationName

        };
        return this.http.post(environment.urlservbeautech + '/api/CustomerCard/SetCustomerCard_3', body).toPromise(); //JSON.stringify(body));
    }

    getCities() {
        return this.http.get<any>(environment.urlservbeautech + '/api/CustomerCard/GetCities')
    }

    async setCities(Cities: City[]) {
        let json = JSON.stringify(Cities);
        const body = json;
        return this.http.post(environment.urlservbeautech + '/api/CustomerCard/SetCities', body).toPromise(); //JSON.stringify(body));
    }

    async setCustomCategories(Categories: CustomCategory[]) {
        let json = JSON.stringify(Categories);
        const body = json;
        return this.http.post(environment.urlservbeautech + '/api/CustomerCard/SetCustomCategories', body).toPromise();
    }


    getWorkers() {
        return this.http.get<any>(environment.urlservbeautech + '/api/CustomerCard/GetWorkers')
    }


    getSourcesArrival() {
        return this.http.get<any>(environment.urlservbeautech + '/api/CustomerCard/GetSourcesArrival')
    }

    async setSourcesArrival(SourcesArrival: SourceArrival[]) {
        let json = JSON.stringify(SourcesArrival);
        const body = json;
        return this.http.post(environment.urlservbeautech + '/api/CustomerCard/SetSourcesArrival', body).toPromise();
    }


    getOccupation() {
        return this.http.get<any>(environment.urlservbeautech + '/api/CustomerCard/GetOccupation')
    }



    async setOccupation(Occupation: Occupation[]) {
        let json = JSON.stringify(Occupation);
        const body = json;
        return this.http.post(environment.urlservbeautech + '/api/CustomerCard/SetOccupations', body).toPromise();
    }




    getProposal(customerin: CustomerIn) {
        const body = { customer_id: customerin.customer_id };
        return this.http.post(environment.urlservbeautech + '/api/CustomerCard/GetProposals', JSON.stringify(body));
    }


    async setProposal(Proposal: Proposal[]) {
        let json = JSON.stringify(Proposal);
        const body = json;
        return this.http.post(environment.urlservbeautech + '/api/CustomerCard/SetProposals', body).toPromise();
    }

    getSubscriber(customerin: CustomerIn) {
        const body = { customer_id: customerin.customer_id };
        return this.http.post(environment.urlservbeautech + '/api/CustomerCard/GetAllSubscribers', JSON.stringify(body));
    }

    getFullComment(commentin: CommentIn) {
        const body = { indInDB: commentin.indInDB, iscomment: commentin.isComment };
        return this.http.post(environment.urlservbeautech + '/api/CustomerCard/GetFullComment', JSON.stringify(body));
    }


    getCustomWarn_Importance() {
        return this.http.get<any>(environment.urlservbeautech + '/api/CustomerCard/GetCustomWarnImportance')
    }


    async setSubscriber(Subscriber: Subscriber) {
        let json = JSON.stringify(Subscriber);
        const body = json;
        return this.http.post(environment.urlservbeautech + '/api/CustomerCard/SetSubscribers', body).toPromise();
    }


    getServicesSubscriber(customerin: CustomerIn) {
        const body = { customer_id: customerin.customer_id };
        return this.http.post(environment.urlservbeautech + '/api/CustomerCard/GetServicesSubscriber', JSON.stringify(body));
    }

    getFilesExtension() {
        return this.http.get<any>(environment.urlservbeautech + '/api/CustomerCard/GetFilesExtension')
    }

    getCardsColor(customerin: CustomerIn) {
        const body = { customer_id: customerin.customer_id };
        return this.http.post(environment.urlservbeautech + '/api/CustomerCard/GetCardsColor', JSON.stringify(body));
    }

    getServicesCardColor() {
        return this.http.get<any>(environment.urlservbeautech + '/api/CustomerCard/GetServicesCardColor')
    }

    getIconsServices() {
        return this.http.get<any>(environment.urlservbeautech + '/api/CustomerCard/GetIconsServices')
    }

    async setServicesCardColor(servicesCardColor: ServiceCardColor[]) {
        let json = JSON.stringify(servicesCardColor);
        const body = json;
        return this.http.post(environment.urlservbeautech + '/api/CustomerCard/SetServicesCardColor', body).toPromise();
    }


    async setCardsColor(cardsColor: CardColor[]) {
        let json = JSON.stringify(cardsColor);
        const body = json;
        return this.http.post(environment.urlservbeautech + '/api/CustomerCard/SetCardsColor', body).toPromise();
    }

    getVisit(customerin: CustomerIn) {
        const body = { customer_id: customerin.customer_id };
        return this.http.post(environment.urlservbeautech + '/api/CustomerCard/GetAllVisits', JSON.stringify(body));
    }

    getVisitByStep(customerstepvisitin: CustomerStepVisitIn) {
        const body = { customer_id: customerstepvisitin.customer_id, dateevent: customerstepvisitin.dateEvent };
        return this.http.post(environment.urlservbeautech + '/api/CustomerCard/GetVisitsByStep', JSON.stringify(body));
    }

    //CustomerStepVisitIn

    getVisitDetails(stripin: StripIn) {
        const body = { customerid: stripin.customerId, datevisit: stripin.dateVisit, numcolor: stripin.numColor };
        return this.http.post(environment.urlservbeautech + '/api/CustomerCard/GetSubStripsVisit', body);
    }

    async setVisits(visits: StripVisit[]) {
        //please don't change this code
        // this json to be use in procedure db

        let json = JSON.stringify(visits);
        const body = json;
        return this.http.post(environment.urlservbeautech + '/api/CustomerCard/SetStripsVisits', body).toPromise();
    }


    async setSubStripsVisits(SubStripsVisits: SubStripVisit[][], keylength: number) {
        //please don't change this code
        // this json to be use in procedure db

        let resultArray: SubStripVisit[] = [];
        var keys = Object.keys(SubStripsVisits)
        keys.forEach(function (key) {
            /*  console.log(key); 
             console.log(SubStripsVisits[key]) */
            if (key.length === keylength) {
                resultArray.push(SubStripsVisits[key]);
            }
        })

        let json = JSON.stringify(resultArray);
        const body = json;
        return this.http.post(environment.urlservbeautech + '/api/CustomerCard/SetVisitsSubStrips', body).toPromise();
    }



    deleteCustCard(customerin: CustomerIn) {
        const body = { customer_id: customerin.customer_id };
        return this.http.post(environment.urlservbeautech + '/api/Customers/DeleteCustomerCard', JSON.stringify(body));
    }

    IsCustExistbyPhone(phone: Pelephone): Observable<IsCustomerPhone> {
        const body = { phoneIn: phone.phoneIn };
        return this.http.post(environment.urlservbeautech + '/api/Customers/IsCustExistbyPhone', JSON.stringify(body)) as Observable<IsCustomerPhone>;
    }

}